import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import SideDots from "@/components/SideDots";
import Cover from "@/components/sections/Cover";
import BrandStory from "@/components/sections/BrandStory";
import CategoryWins from "@/components/sections/CategoryWins";
import World from "@/components/sections/World";
import ExtendedCollections from "@/components/sections/ExtendedCollections";
import Experience from "@/components/sections/Experience";
import Celebrity from "@/components/sections/Celebrity";
import RetailDisplay from "@/components/sections/RetailDisplay";
import Partnership from "@/components/sections/Partnership";
import Global from "@/components/sections/Global";
import Contact from "@/components/sections/Contact";

export default function Presentation() {
  return (
    <>
      <Navigation />
      <SideDots />
      <main id="deck" className="deck-container" data-testid="deck-container">
        <Cover />
        <BrandStory />
        <CategoryWins />
        <World />
        <ExtendedCollections />
        <Experience />
        <Celebrity />
        <RetailDisplay />
        <Partnership />
        <Global />
        <Contact />
      </main>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#F7F4EE",
            border: "1px solid rgba(200,164,106,0.3)",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </>
  );
}
